export const appPageTransition = {"name":"page"}

export const appLayoutTransition = {"name":"layout","mode":"out-in"}

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"apple-itunes-app","content":"app-id=6802304361"},{"property":"og:type","content":"website"},{"property":"og:title","content":"CarFree Wypożyczalnia Samochodów"},{"property":"og:description","content":"CarFree - Ogólnopolska Wypożyczalnia Aut w Warszawie. Kaucja 0 zł, Brak Limitu Kilometrów. Zapraszamy 24h/365 dni w roku! ☎️ +48 794 500 550"},{"property":"og:image","content":"https://carfree.pl/car-free-1200x630.jpg"},{"property":"og:site_name","content":"CarFree"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"CarFree Wypożyczalnia Samochodów"},{"name":"twitter:description","content":"CarFree - Ogólnopolska Wypożyczalnia Aut w Warszawie. Kaucja 0 zł, Brak Limitu Kilometrów. Zapraszamy 24h/365 dni w roku! ☎️ +48 794 500 550"},{"name":"twitter:image","content":"https://carfree.pl/car-free-1200x630.jpg"}],"link":[{"rel":"preconnect","href":"https://prod-api.carfree.pl","crossorigin":"use-credentials"},{"rel":"dns-prefetch","href":"https://prod-api.carfree.pl"},{"rel":"preconnect","href":"https://carfree-prod.fra1.cdn.digitaloceanspaces.com"},{"rel":"dns-prefetch","href":"https://carfree-prod.fra1.cdn.digitaloceanspaces.com"},{"rel":"preconnect","href":"https://www.googletagmanager.com"},{"rel":"dns-prefetch","href":"https://www.googletagmanager.com"},{"rel":"preload","as":"font","href":"/fonts/Satoshi-Regular.woff2","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"/fonts/Satoshi-Bold.woff2","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"/fonts/Satoshi-Medium.woff2","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"/fonts/GT-Pressura-LG-Standard-Medium.woff2","type":"font/woff2","crossorigin":"anonymous"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-icon-57x57.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"shortcut icon","href":"/favicon.ico"}],"style":[],"script":[{"innerHTML":"\n\t\t\t\t\t\twindow.dataLayer = window.dataLayer || [];\n\t\t\t\t\t"},{"innerHTML":"\n\t\t\t\t\t\t(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&amp;l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-NG965CMN');\n\t\t\t\t\t"}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"prefetchOn":{"interaction":true,"visibility":false},"componentName":"NuxtLink","prefetch":true}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false